import { render, staticRenderFns } from "./DocumentosCRUD.vue?vue&type=template&id=53dd1edd"
import script from "./DocumentosCRUD.vue?vue&type=script&lang=js"
export * from "./DocumentosCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports